/**
 * Add bottom padding to body when sticky bar is visible.
 * Footer box-shadow handles the dark background below.
 */
document.addEventListener("DOMContentLoaded", () => {
  const sticky = document.querySelector('[class*="ai-hero-product__sticky-bar"]');
  if (!sticky) return;

  const body = document.body;

  const updatePadding = () => {
    if (sticky.classList.contains('visible')) {
      body.style.paddingBottom = `${sticky.offsetHeight}px`;
    } else {
      body.style.paddingBottom = '';
    }
  };

  const observer = new MutationObserver(updatePadding);
  observer.observe(sticky, {
    attributes: true,
    attributeFilter: ['class']
  });

  updatePadding();
  window.addEventListener('resize', updatePadding);
});
